import Theme from '../../types/UI/Theme';

const defaultTheme: Theme = {
    logo: undefined,
    borderRadius: 'soft',
    fonts: {
        body: 'Rubik',
        title: 'Rubik',
    },
    colors: {
        neutral: {
            name: 'Belize Blue',
            tints: {
                '000': '#ffffff',
                '100': '#f4f9ff',
                '200': '#e5f2ff',
                '300': '#cce5ff',
                '400': '#7ca8d3',
                '500': '#2270bd',
                '600': '#004c99',
                '700': '#003870',
                '800': '#00162d',
                '900': '#000000',
            },
            text: {
                default: '#003870',
                subdued: '#7ca8d3',
            },
        },
        brand: {
            default: { tint: '#5cc314', contrast: '#fff' },
            darker: { tint: '#51ac11', contrast: '#fff' },
            lighter: { tint: '#68da16', contrast: '#fff' },
            lighterer: { tint: '#a8c995', contrast: '#fff' },
        },
    },
};

export default defaultTheme;
